export default __webpack_public_path__ + "1cf92f045fd7c0b40773a56b09cdfa88.png";